<template>
  <div
    class="w-full h-full flex flex-col items-center justify-center bg-white p-6"
  >
    <div v-if="error" class="text-center">
      <div
        class="w-16 h-16 bg-red-100 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h2 class="text-xl font-bold text-slate-800 mb-2">Lien invalide</h2>
      <p class="text-slate-500 mb-6">{{ error }}</p>
      <button
        @click="goHome"
        class="px-6 py-3 bg-primary text-white font-semibold rounded-xl w-full ripple"
      >
        Retour à l'accueil
      </button>
    </div>
    <div v-else class="text-center">
      <div class="w-24 h-24 mx-auto mb-4 rounded-3xl overflow-hidden shadow">
        <ImgComponent src="/images/logo.png" alt="Rapidoo" />
      </div>
      <h2 class="text-xl font-bold text-slate-800 mb-2">Rapidoo</h2>
      <button
        @click="goHome"
        class="px-6 py-3 bg-primary text-white font-semibold rounded-xl w-full ripple"
      >
        Ouvrir rapidoo
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const { proxy } = getCurrentInstance();
const { $bus, $constants } = proxy;

const error = ref(null);

const goHome = () => {
  router.replace({ name: 'home' });
};

onMounted(() => {
  try {
    const encodedData = route.params.data;
    if (!encodedData) throw new Error('Aucune donnée à décoder');

    const decodedStr = atob(encodedData);
    const data = JSON.parse(decodedStr);

    console.log('🚀 ~ data:', data);
    if (!data || !data.t || !data.id) {
      throw new Error('Données de partage corrompues');
    }

    setTimeout(() => {
      if (data.t === 'r') {
        $bus.emit('restaurant.SHOW_RESTAURANT_DETAIL', {
          id: data.id
        });
      } else if (data.t === 'd') {
        $bus.emit('dish.SHOW_DISH_DETAIL', {
          id: data.id
        });
      } else {
        throw new Error('Type de partage inconnu');
      }
    }, 500);
  } catch (err) {
    console.error('Erreur lors du décodage du lien partagé:', err);
    error.value = 'Ce lien de partage semble invalide ou a expiré.';
    $bus?.emit($constants?.EVENTS?.TOAST_NOTIFICATION?.SHOW || 'toast.show', {
      title: 'Erreur de lien',
      body: error.value
    });
  }
  // goHome()
});
</script>
